<input [type]="type" (change)="onInputFileChange($event)" [accept]="accept" style="display: none;" [multiple]="allowMultiple? true: false" #inputFile/>
<ion-action-sheet [header]="header" [subHeader]="subHeader" [buttons]="buttons" #actionSheet>
</ion-action-sheet>
